import MainLayout from '../layouts/main';
import ExamReportsListContainer from './container';

function examReportsPage() {
  return (
    <MainLayout>
      <ExamReportsListContainer/>
    </MainLayout>
  );
}

export default examReportsPage;
